import { CalendarOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '~/app/utils/format-date-time';
import styles from './AssetOcppConfigurationFetchedAt.module.css';

export interface AssetOcppConfigurationFetchedAtProps {
  fetchedAt: string | null;
}

export function AssetOcppConfigurationFetchedAt({
  fetchedAt,
}: AssetOcppConfigurationFetchedAtProps) {
  const { t } = useTranslation('assets');

  if (!fetchedAt) {
    return (
      <span className={`${styles.meta} ${styles.metaEmpty}`}>
        <CalendarOutlined aria-hidden className={styles.icon} />
        <span className={styles.label}>
          {t(
            'detail.ocppConfiguration.neverFetched',
            'No successful fetch yet',
          )}
        </span>
      </span>
    );
  }

  return (
    <span className={styles.meta} title={formatDateTime(fetchedAt)}>
      <CalendarOutlined aria-hidden className={styles.icon} />
      <span className={styles.label}>
        {t(
          'detail.ocppConfiguration.lastFetchedLabel',
          'Last successful fetch',
        )}
      </span>
      <time className={styles.timestamp} dateTime={fetchedAt}>
        {formatDateTime(fetchedAt)}
      </time>
    </span>
  );
}
